import { Box } from '@mui/material';
const TabPanel = ({ children, value, index }) => {
  return (
    <div
      hidden={value !== index}
      role="tabpanel"
      id={`custom-tabpanel-${index}`}
      aria-labelledby={`custom-tab-${index}`}>
      {value === index && <div>{children}</div>}
    </div>
  );
};

export default TabPanel;
